<template>
    <div class="address-box">
        <select class="from-input address" id="address" required @change="startzhou($event)" v-model="startAreaZhou">
            <option disabled selected value="0">请选择</option>
            <option v-for="(item,index) in arealistZhou" :value="item.id">{{item.name}}</option>
        </select>
        <select class="from-input address" id="guojiaaddress" required @change="startguojia($event)" v-model="startAreaGuojia">
            <option disabled selected value="0">请选择</option>
            <option v-for="(item,index) in arealistGuojia" :value="item.id">{{item.name}}</option>
        </select>
        <select class="from-input address " id="shengaddress" required @change="startsheng($event)" v-model="startAreaSheng">
            <option disabled selected value="0">请选择</option>
            <option v-for="(item,index) in arealistSheng" :value="item.id">{{item.name}}</option>
        </select>
        <select class="from-input address " id="shiaddress" required @change="startshi($event)" v-model="startAreaShi">
            <option disabled selected value="0">请选择</option>
            <option v-for="(item,index) in arealistShi" :value="item.id">{{item.name}}</option>
        </select>
        <select class="from-input address " id="diquaddress" required @change="startqu($event)" v-model="startAreaQu">
            <option disabled selected value="0">请选择</option>
            <option v-for="(item,index) in arealistQu" :value="item.id">{{item.name}}</option>
        </select>
    </div>
</template>
<script>
    export default{
        data(){
            return {
                // 出发
                arealistUrl:'', //地区路径
                arealistZhou:'', //地区 洲
                arealistGuojia:'', //地区 国家
                arealistSheng:'', //地区 省
                arealistShi:'', //地区 市
                arealistQu:'', //地区 区
                arealistId:0, //地区的id
                // 出发地区
                startAreaZhou:'0', //出发地区 洲
                startAreaGuojia:'0', //出发地区 国家
                startAreaSheng:'0', //出发地区 省
                startAreaShi:'0', //出发地区 市
                startAreaQu:'0', //出发地区 区
            }
        },
        // props:['startpath'],
        computed:{
            AreaList(){ // 地区
                return this.$store.state.interface.areaList;
            },
        },
        methods:{
           startzhou(event){ //出发地区 洲
                // event.target.style.color = '#7f889c';
                var Sons;
                var self= this;
                for(var i in this.arealistZhou){
                    if( this.arealistZhou[i].id ==event.target.value){
                        // this.thenewproduct.startCity=this.arealistZhou[i].name;
                        // this.thenewproduct.startPath=this.arealistZhou[i].path;
                        this.$emit('DeparTure',this.arealistZhou[i].name,this.arealistZhou[i].path);//传值
                        Sons=this.arealistZhou[i].sons;
                    }
                };
                $(event.target).nextAll('.address').hide();
                this.startAreaGuojia=0; //出发地区 国家
                this.startAreaSheng=0; //出发地区 省
                this.startAreaShi=0; //出发地区 市
                this.startAreaQu=0; //出发地区 区
                this.arealistGuojia='';//地区 国家
                this.arealistSheng=''; //地区 省
                this.arealistShi=''; //地区 市
                this.arealistQu=''; //地区 区
                if(!Sons == 0){
                    this.$ajax.post(this.arealistUrl+'?fid='+event.target.value).then(function(res){
                        var areaList= res.data.result;
                        for(var i in areaList){
                            self.arealistGuojia = areaList[i];
                        };
                        if (res.data.code == '10000'){
                            $(event.target).next('.address').show();
                        }
                    },function(res){

                    })
                }
                
            },
            startguojia(event){ //出发地区 国家
                // event.target.style.color = '#7f889c';
                var Sons;
                var self= this;
                for(var i in this.arealistGuojia){
                    if( this.arealistGuojia[i].id ==event.target.value){
                        // this.thenewproduct.startCity=this.arealistGuojia[i].name;
                        // this.thenewproduct.startPath=this.arealistGuojia[i].path;
                        this.$emit('DeparTure',this.arealistGuojia[i].name,this.arealistGuojia[i].path);//传值
                        Sons=this.arealistGuojia[i].sons;
                    }
                };
                $(event.target).nextAll('.address').hide();
                this.startAreaSheng=0; //出发地区 省
                this.startAreaShi=0; //出发地区 市
                this.startAreaQu=0; //出发地区 区
                this.arealistSheng=''; //地区 省
                this.arealistShi=''; //地区 市
                this.arealistQu=''; //地区 区
                if(!Sons == 0){
                    this.$ajax.post(this.arealistUrl+'?fid='+event.target.value).then(function(res){
                        var areaList= res.data.result;
                        for(var i in areaList){
                            self.arealistSheng = areaList[i];
                        };
                        
                        if (res.data.code == '10000'){
                            $(event.target).next('.address').show();
                            // $('.shengaddress').show();
                        }
                    },function(res){

                    })
                }
                
            },
            startsheng(event){ //出发地区 省
                // event.target.style.color = '#7f889c';
                var Sons;
                var self= this;
                for(var i in this.arealistSheng){
                    if( this.arealistSheng[i].id ==event.target.value){
                        // this.thenewproduct.startCity=this.arealistSheng[i].name;
                        // this.thenewproduct.startPath=this.arealistSheng[i].path;
                        this.$emit('DeparTure',this.arealistSheng[i].name,this.arealistSheng[i].path);//传值
                        Sons=this.arealistSheng[i].sons;
                    }
                };
                $(event.target).nextAll('.address').hide();
                this.startAreaShi=0; //出发地区 市
                this.startAreaQu=0; //出发地区 区
                this.arealistShi=''; //地区 市
                this.arealistQu=''; //地区 区
                if(!Sons == 0){
                    this.$ajax.post(this.arealistUrl+'?fid='+event.target.value).then(function(res){
                        var areaList= res.data.result;
                        for(var i in areaList){
                            self.arealistShi = areaList[i];
                        };
                        if (res.data.code == '10000'){
                            $(event.target).next('.address').show();
                        }
                    },function(res){

                    })
                }
            },
            startshi(event){ //出发地区 市
                // event.target.style.color = '#7f889c';
                var Sons;
                var self= this;
                for(var i in this.arealistShi){
                    if( this.arealistShi[i].id ==event.target.value){
                        // this.thenewproduct.startCity=this.arealistShi[i].name;
                        // this.thenewproduct.startPath=this.arealistShi[i].path;
                        this.$emit('DeparTure',this.arealistShi[i].name,this.arealistShi[i].path);//传值
                        Sons=this.arealistShi[i].sons;
                    }
                };
                $(event.target).nextAll('.address').hide();
                this.startAreaQu=0; //出发地区 区
                this.arealistQu=''; //地区 区
                if(!Sons == 0){
                    this.$ajax.post(this.arealistUrl+'?fid='+event.target.value).then(function(res){
                        var areaList= res.data.result;
                        for(var i in areaList){
                            self.arealistQu = areaList[i];
                        };
                        if (res.data.code == '10000'){
                            $(event.target).next('.address').show();
                        }
                    },function(res){

                    })
                }
            },
            startqu(event){ //出发地区 区
                // event.target.style.color = '#7f889c';
                var Sons;
                for(var i in this.arealistQu){
                    if( this.arealistQu[i].id ==event.target.value){
                        // this.thenewproduct.startCity=this.arealistQu[i].name;
                        // this.thenewproduct.startPath=this.arealistQu[i].path;
                        this.$emit('DeparTure',this.arealistQu[i].name,this.arealistQu[i].path);//传值
                        Sons=this.arealistQu[i].sons;
                    }
                };
            },
        },
        beforeMount(){
            var self= this;
            var url = this.TheNewProduct;
            this.arealistUrl=this.AreaList; // 地址

            // this.$ajax.post(this.arealistUrl+'?fid='+this.arealistId).then(function(res){
            this.$ajax.post(this.arealistUrl+'?fid='+this.arealistId).then(function(res){
                var areaList= res.data.result;
                for(var i in areaList){
                    self.arealistZhou = areaList[i];
                };
            },function(res){
            })
        
            
        },
    }
</script>
<style lang="scss" scoped>
    .address{
        display: none;
        border-right: 1px solid #ddd !important;
        width: 20% !important;
        float: left;
    }
    .address:first-of-type{
        display:inline;
        margin-left: 0;
    }
    .address:last-of-type{
        border-right: 0 !important;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/public/site.vue